import { useBerichtenProlongatiewijzigingenOphalen } from '@services/communicatie-public/orval-api/berichten-api/berichten-api';
import { computed, type MaybeRefOrGetter } from 'vue';
import { useRouteRelatienummer } from './route-relatienummer';

export function useProlongatie(options?: {
  enabled?: MaybeRefOrGetter<boolean | undefined>;
  staleTime?: MaybeRefOrGetter<number>;
}) {
  const relatienummer = useRouteRelatienummer();

  return useBerichtenProlongatiewijzigingenOphalen(
    computed(() => ({
      relatienummer: relatienummer.value,
    })),
    {
      query: {
        ...options,
        select: ({ result }) => result,
      },
    },
  );
}
